import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

import { IMarketing, defaultValue, ISearchForm } from 'app/shared/model/marketing.model';
import { flattenKey } from 'app/shared/util/object-utils';
import * as qs from 'qs';
import moment from 'moment';
// 请求
export const ACTION_TYPES = {
  FETCH_MARKETING_LIST: 'marketing/FETCH_MARKETING_LIST',
  FETCH_MARKETING: 'marketing/FETCH_MARKETING',
  CREATE_MARKETING: 'marketing/CREATE_MARKETING',
  UPDATE_MARKETING: 'marketing/UPDATE_MARKETING',
  DELETE_MARKETING: 'marketing/DELETE_MARKETING',
  PUBLISH_MARKETING: 'marketing/PUBLISH_MARKETING',
  CANCEL_MARKETING: 'marketing/CANCEL_MARKETING',
  RESET: 'marketing/RESET'
};
// state
const initialState = {
  loading: false,
  fetching: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IMarketing>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false
};

export type MarketingState = Readonly<typeof initialState>;

// Reducer

export default (state: MarketingState = initialState, action): MarketingState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_MARKETING_LIST):
    case REQUEST(ACTION_TYPES.FETCH_MARKETING):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true
      };
    case REQUEST(ACTION_TYPES.CREATE_MARKETING):
    case REQUEST(ACTION_TYPES.UPDATE_MARKETING):
    case REQUEST(ACTION_TYPES.DELETE_MARKETING):
    case REQUEST(ACTION_TYPES.PUBLISH_MARKETING):
    case REQUEST(ACTION_TYPES.CANCEL_MARKETING):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true
      };
    case FAILURE(ACTION_TYPES.FETCH_MARKETING_LIST):
    case FAILURE(ACTION_TYPES.FETCH_MARKETING):
    case FAILURE(ACTION_TYPES.CREATE_MARKETING):
    case FAILURE(ACTION_TYPES.UPDATE_MARKETING):
    case FAILURE(ACTION_TYPES.DELETE_MARKETING):
    case FAILURE(ACTION_TYPES.PUBLISH_MARKETING):
    case FAILURE(ACTION_TYPES.CANCEL_MARKETING):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload
      };
    case SUCCESS(ACTION_TYPES.FETCH_MARKETING_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
        totalItems: parseInt(action.payload.headers['x-total-count'], 10)
      };
    case SUCCESS(ACTION_TYPES.FETCH_MARKETING):
      const formEntity: IMarketing = { ...action.payload.data };
      formEntity.startAt = moment(formEntity.startAt);
      formEntity.endAt = moment(formEntity.endAt);
      const houseIds = [];
      formEntity.houses.map(item => {
        houseIds.push(item.id);
      });
      formEntity.houseIds = houseIds;
      formEntity.marketingItems.map(item => {
        if (item.name === '房租') {
          formEntity.marketingRoomRent = item.singleMonthDecreaseAmount;
        }
        if (item.name === '物业费') {
          formEntity.marketingPropertyCharges = item.singleMonthDecreaseAmount;
        }
      });
      return {
        ...state,
        loading: false,
        entity: { ...formEntity }
      };
    case SUCCESS(ACTION_TYPES.CREATE_MARKETING):
    case SUCCESS(ACTION_TYPES.UPDATE_MARKETING):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.PUBLISH_MARKETING):
    case SUCCESS(ACTION_TYPES.CANCEL_MARKETING):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload
      };
    case SUCCESS(ACTION_TYPES.DELETE_MARKETING):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {}
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

const apiUrl = 'api/marketings'; // 营销活动

// Actions
// 营销活动列表
export const getEntities = (page?: any, size?: any, sort = 'createdAt,desc', searchForm?: ISearchForm) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
  return {
    type: ACTION_TYPES.FETCH_MARKETING_LIST,
    payload: axios.get<IMarketing>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`, {
      params: flattenKey(searchForm),
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'indices' })
    })
  };
};
// 营销活动详情
export const getEntity: ICrudGetAction<IMarketing> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_MARKETING,
    payload: axios.get<IMarketing>(requestUrl)
  };
};

export const publiceEntity: ICrudPutAction<IMarketing> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}/publish`;
  const result = await dispatch({
    type: ACTION_TYPES.PUBLISH_MARKETING,
    payload: axios.put<IMarketing>(requestUrl)
  });
  dispatch(getEntities());
  return result;
};
// 取消营销活动
export const cancelEntity: ICrudPutAction<IMarketing> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}/cancel`;
  const result = await dispatch({
    type: ACTION_TYPES.CANCEL_MARKETING,
    payload: axios.put<IMarketing>(requestUrl)
  });
  dispatch(getEntities());
  return result;
};
// 创建营销活动
export const createEntity: ICrudPutAction<IMarketing> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_MARKETING,
    payload: axios.post(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities());
  return result;
};
// 创建营销活动s
export const createEntitys = entities => async dispatch => {
  const datas = entities.map(item => cleanEntity(item));
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_MARKETING,
    payload: axios.post(`${apiUrl}/createBatch`, datas)
  });
  dispatch(getEntities());
  return result;
};
// 更新营销活动
export const updateEntity: ICrudPutAction<IMarketing> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_MARKETING,
    payload: axios.put(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities());
  return result;
};
// 删除营销活动
export const deleteEntity: ICrudDeleteAction<IMarketing> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_MARKETING,
    payload: axios.delete(requestUrl)
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET
});
